import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";

export const mfaApi = createApi({
  reducerPath: "mfaApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["MFA"],
  endpoints: (builder) => ({
    generateMFASecret: builder.mutation({
      query: () => ({
        url: "/auth/generate-secret",
        method: "GET",
      }),
    }),
    verifyMFASecret: builder.mutation({
      query: (token) => ({
        url: "/auth/verify-mfa-secret",
        method: "POST",
        body: { token },
      }),
    }),
    verifyMFA: builder.mutation({
      query: (data) => ({
        url: "/auth/verify-mfa",
        method: "POST",
        body: data,
      }),
    }),
    enableMFA: builder.mutation({
      query: (data) => ({
        url: "/auth/enable-mfa",
        method: "POST",
        body: data,
      }),
    }),
    disableMFA: builder.mutation({
      query: () => ({
        url: "/auth/disable-mfa",
        method: "POST",
      }),
    }),
    sendMFACode: builder.mutation({
      query: (data = {}) => ({
        url: "/auth/send-mfa-code",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useGenerateMFASecretMutation,
  useVerifyMFASecretMutation,
  useVerifyMFAMutation,
  useEnableMFAMutation,
  useDisableMFAMutation,
  useSendMFACodeMutation,
} = mfaApi;
